import { Mapper } from '../../../common/ddd/mapper.base';
import { formatDeviation } from '../../../common/utils/format-deviation.util';
import { formatDuration } from '../../../common/utils/format-duration.util';
import { ChallengeTimeInCategoriesAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-time-in-categories.aggregate-root';
import { MetricValueType } from '../../../interface/dtos';
import { GetAccountMetricsInsightsAveragesResponseDto } from '../../../interface/dtos/challenge-insights/get-account-metrics-insights-averages.response.dto';

export class ChallengeTimeInCategoryAggregateRootMapper
  implements
    Omit<
      Mapper<
        ChallengeTimeInCategoriesAggregateRoot,
        GetAccountMetricsInsightsAveragesResponseDto
      >,
      'toDomain'
    >
{
  toResponse(
    entity: ChallengeTimeInCategoriesAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return ChallengeTimeInCategoryAggregateRootMapper.toResponse(entity);
  }
  static toResponse(
    entity: ChallengeTimeInCategoriesAggregateRoot
  ): GetAccountMetricsInsightsAveragesResponseDto {
    return {
      deviation: `${formatDeviation(Math.round(entity.deviationPercentage))}`,
      beforeValue: Math.round(entity.beforeValue),
      afterValue: Math.round(entity.value),
      beforeFormattedValue:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.beforeValue))
          : formatDuration(entity.beforeValue),
      afterFormattedValue:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.value))
          : formatDuration(entity.value),
      averageDeviation: `${formatDeviation(
        Math.round(entity.averageDeviationPercentage)
      )}`,
      beforeAverage: Math.round(entity.beforeAverage),
      afterAverage: Math.round(entity.average),
      beforeFormattedAverage:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.beforeAverage))
          : formatDuration(entity.beforeAverage),
      afterFormattedAverage:
        entity.type === MetricValueType.Interactions ||
        entity.type === MetricValueType.UniqueUsers
          ? String(Math.round(entity.average))
          : formatDuration(entity.average),
    };
  }
}
